<template>
  <div :class="['pdp-sticky-cta-bar', { '-is-vip': isVip() }]">
    <div class="pdp-sticky-cta-container">
      <div class="pdp-sticky-cta">
        <PDPShipping
          v-if="!isVip()"
          :isSticky="true"
          class="dp-none dp-md-block"
        />

        <PDPStickyCTAPricing
          v-if="!isVip()"
          @openPaymentMethod="$emit('openPaymentMethod')"
        />

        <PDPStickyCTAButton>
          <slot name="cta"></slot>
        </PDPStickyCTAButton>

        <div
          v-if="!isSoldOut && !isBnn && !isVip()"
          class="payment-learn-more dp-block dp-md-none"
        >
          <v-btn
            :color="isBnn ? '#eba614' : 'primary'"
            :ripple="false"
            plain
            width="fit-content"
            height="fit-content"
            class="btn-link"
            @click="$emit('openPaymentMethod')"
          >
            ดูเพิ่มเติมเกี่ยวกับการผ่อนชำระ
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  name: 'PDPStickyCTA',

  props: {
    isSoldOut: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    PDPStickyCTAPricing: () => import('./PDPStickyCTAPricing.vue'),
    PDPStickyCTAButton: () => import('./PDPStickyCTAButton.vue'),
    PDPShipping: () => import('./PDPShipping.vue'),
  },

  inject: ['isVip'],

  data() {
    return {
      isBnn,
    }
  },
}
</script>

<style lang="stylus" scoped>
/* BaNANA PDP Sticky CTA */
.-is-bnn {
	.pdp-sticky-cta-bar {
		background-color: #f8f8f8
	}
}

/* Studio7 PDP Sticky CTA */
.pdp-sticky-cta-bar {
    position: fixed;
    bottom: 0;
    z-index: 10

    width: 100vw;

    background-color: $color-dapp-gray-4;
    box-shadow: inset 0 .03125rem 0 0 #d2d2d7
}
.pdp-sticky-cta-container {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
    padding: 16px;

    @media screen and (min-width: 768px) and (max-width: 1252px) {
        padding: 16px;
    }

    @media screen and (min-width: 1024px) {
        padding: 20px 12px;
    }

}
.pdp-sticky-cta {
    width: 100%;
    max-width: 100%;
    justify-content: center;
    align-items: center;

    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(36px, auto);

    @media screen and (min-width: 768px) {
        align-items: center;
        justify-content: space-between;
        grid-template-columns: repeat(3, 2fr);
        grid-auto-rows: minmax(50px, auto);
    }
}

.btn-link {
    padding 0 !important
}

.payment-learn-more {
    grid-column: 1 / span 2;
    text-align: right;
}

.-is-vip {
	.pdp-sticky-cta {
		grid-template-columns: repeat(1, 1fr);
	}
}
</style>
